module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAP1BMVEUAAAB/f394eHh4eHh4eHh3d3d4eHh/f393d3d6enp0dHR5eXl4eHh4eHh1dXV3d3eFhYV4eHh4eHh9fX14eHjq7/1RAAAAFHRSTlMAEM+f77ffCCAwGChK/Cf9F/bxPSS+Mb8AAABuSURBVHja5dEFCkMxGITBeFK33P+spfjPnKC8xT8G3XSM5eTmTGG1qGbvQZ3HRs2+2yWU9VOYUygqjUqj0qg0Ko1Ko3pqVG8Mu7/27UPli4cP+dd1qPxroTRJpVFpVBqVRqVRaVQxYJJxYYh/uC8YZQc/Sx28TwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/乘号.png
// module id = vTQC
// module chunks = 2